import { DealDisqualificationRuleId, DealDisqualificationRuleRequest, DealDisqualificationRuleResponse } from '@business/entities/deal';
import { Endpoint } from '@business/api/endpoint';

export function fetchRules() {
  return Endpoint.get<DealDisqualificationRuleResponse[]>('@gc/deal-disqualification-rules');
}

export function createRule(data: DealDisqualificationRuleRequest) {
  return Endpoint.post<DealDisqualificationRuleResponse>('@gc/deal-disqualification-rules', { data });
}

export function deleteRule(id: DealDisqualificationRuleId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/deal-disqualification-rules/${id}`);
}
